<div class="fixed z-50" aria-labelledby="batch-payment-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-[#363738] bg-opacity-25 backdrop-blur-sm transition-opacity dark:bg-[#3333331f]"
    (click)="closeModal.emit()"></div>
  <div class="fixed inset-0 flex items-center justify-center p-4">
    <div
      class="relative flex w-full max-w-md flex-col rounded-lg border border-zinc-950/10 bg-white shadow-xl dark:border-white/10 dark:bg-zinc-950">
      <div class="flex items-center justify-between border-b border-zinc-200 px-4 py-2 dark:border-white/10">
        <h3 class="heading" id="batch-payment-title">Receive Payment ({{ count }} invoices)</h3>
        <button (click)="closeModal.emit()" type="button"
          class="rounded-md bg-white text-zinc-500 hover:text-zinc-700 focus:ring-2 focus:ring-primary dark:bg-white/5 dark:text-white dark:hover:text-zinc-300">
          <span class="sr-only">Close</span>
          <svg aria-hidden="true" class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="1.5"
            viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </button>
      </div>
      <div class="space-y-1 p-4">
        <label class="subheading">Deposit to account</label>
        <select [(ngModel)]="accountId">
          <option value="">Undeposited Funds (default)</option>
          <option *ngFor="let account of accounts" [value]="account.Id">{{ account.Name }}</option>
        </select>
        <p class="pt-1 text-xs-light">Each selected invoice is paid in full. Invoices that are already paid are skipped.</p>
      </div>
      <div class="flex justify-end gap-2 border-t border-zinc-200 px-4 py-2 dark:border-white/10">
        <button type="button" class="btn btn-secondary" (click)="closeModal.emit()">Cancel</button>
        <button type="button" class="btn btn-primary" [disabled]="loading" (click)="onConfirm()">Pay</button>
      </div>
    </div>
  </div>
</div>
